var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Slide',{attrs:{"fullWidth":""}},[_c('Slider',{attrs:{"items":_vm.projects},on:{"scrollChange":function (data) { return _vm.$emit('scrollChange', data); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }